import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import _slicedToArray from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ============================================================
// 课程详情页逻辑
// ============================================================
import { intlMixin } from '@/i18n/intl-i18n';
import IntlBreadcrumb from "../components/IntlBreadcrumb.vue";
import CourseCard from "../components/CourseCard.vue";
import { resolveCourseCover, normalizeCategory } from "../components/courseCover";
import { getCourseDetail, getCourseOutline, getRelatedCourses } from '@/api/international';
var COVER_ICONS = {
  smart: '⚙',
  digital: '▦',
  service: '✦',
  transport: '◈',
  business: '◇',
  culture: '◎',
  zhinengzhizao: '⚙',
  shuzijishu: '▦',
  xiandaifuwu: '✦',
  jiaotongyunshu: '◈',
  caijingshangmao: '◇',
  wenhuayishu: '◎'
};
export default {
  name: 'IntlCourseDetail',
  mixins: [intlMixin],
  components: {
    IntlBreadcrumb: IntlBreadcrumb,
    CourseCard: CourseCard
  },
  data: function data() {
    return {
      course: null,
      outline: [],
      relatedCourses: [],
      activeTab: 'intro',
      loadFailed: false
    };
  },
  computed: {
    coverCategory: function coverCategory() {
      return normalizeCategory(this.course && this.course.category);
    },
    coverImage: function coverImage() {
      return resolveCourseCover(this.course);
    },
    coverIcon: function coverIcon() {
      return COVER_ICONS[this.coverCategory] || '◆';
    },
    langLabel: function langLabel() {
      if (!this.course) return '';
      return this.$intlLangLabel(this.course.selectedLanguage || this.$intlLang);
    },
    courseTitle: function courseTitle() {
      if (!this.course) return '';
      return this.pickLang(this.course, 'title');
    },
    courseDesc: function courseDesc() {
      if (!this.course) return '';
      return this.pickLang(this.course, 'desc');
    },
    courseType: function courseType() {
      if (!this.course) return '';
      return this.course.type || this.$t('courses.defaultType');
    },
    courseInstructor: function courseInstructor() {
      if (!this.course) return '';
      return this.pickLang(this.course, 'instructor');
    },
    courseLevel: function courseLevel() {
      if (!this.course) return '';
      return this.pickLang(this.course, 'level');
    },
    tabs: function tabs() {
      return [{
        key: 'intro',
        label: this.$t('common.intro')
      }, {
        key: 'outline',
        label: this.$t('common.outline')
      }];
    }
  },
  watch: {
    '$intlLang': function $intlLang() {
      this.loadDetail();
    }
  },
  methods: {
    // 后端已按当前语言返回内容，前端不再做多语言字段兜底。
    pickLang: function pickLang(item, base) {
      return item[base] || '';
    },
    chapterTitle: function chapterTitle(chapter) {
      return this.pickLang(chapter, 'title');
    },
    learnCourse: function learnCourse() {
      if (!this.course) return;
      this.$router.push({
        path: '/international/courseLearn',
        query: {
          id: this.course.id
        }
      });
    },
    loadDetail: function () {
      var _loadDetail = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, _yield$Promise$all, _yield$Promise$all2, detailRes, outlineRes, relatedRes, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = this.$route.query.id;
              if (id) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              this.loadFailed = false;
              _context.prev = 2;
              _context.next = 3;
              return Promise.all([getCourseDetail(id), getCourseOutline(id), getRelatedCourses(id)]);
            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              detailRes = _yield$Promise$all2[0];
              outlineRes = _yield$Promise$all2[1];
              relatedRes = _yield$Promise$all2[2];
              if (detailRes.data.code === 200) this.course = detailRes.data.data;
              if (outlineRes.data.code === 200) this.outline = outlineRes.data.data || [];
              if (relatedRes.data.code === 200) this.relatedCourses = relatedRes.data.data || [];
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              console.error('loadDetail', _t);
              this.course = null;
              this.outline = [];
              this.relatedCourses = [];
              this.loadFailed = true;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 4]]);
      }));
      function loadDetail() {
        return _loadDetail.apply(this, arguments);
      }
      return loadDetail;
    }(),
    goDetail: function goDetail(course) {
      // 切换课程时重新加载
      this.course = null;
      this.$router.push({
        path: '/international/courseDetail',
        query: {
          id: course.id
        }
      });
      this.loadDetail();
    }
  },
  mounted: function mounted() {
    this.loadDetail();
  }
};